import classNames from 'classnames'
import React, { ComponentType, MouseEvent } from 'react'

import { GridColumn } from '../grid/grid-column.js'
import { Grid } from '../grid/grid.js'
import { ChevronRightLargeIcon, IconProps } from '../icon/icon.js'

export interface LinkCardProps {
    icon: ComponentType<IconProps>
    text: string
    className?: string
    count?: number
    onClick?: (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void
    url?: string
}

export const LinkCard = (props: LinkCardProps): JSX.Element => {
    const { count, onClick, text, url } = props

    const className: string = classNames('link-card', props.className)

    const Element: 'a' | 'button' = url ? 'a' : 'button'

    let countElement: JSX.Element | null = null

    if (count !== undefined) {
        const maxDimension = Math.max(count.toString().length * 8 + 4, 18)
        const countStyle = {
            width: maxDimension + 'px',
            height: maxDimension + 'px',
        }
        countElement = (
            <span className="link-card__count" style={countStyle}>
                {count}
            </span>
        )
    }

    return (
        <Element className={className} href={url} onClick={onClick}>
            <props.icon className="link-card__icon" />
            <Grid
                className="link-card__grid"
                align={['center-xs', 'start-lg', 'middle-xs']}
                equalHeight={true}
                noWrap={true}
            >
                <GridColumn width={['xs', 'max-lg']}>
                    <span className="link-card__text h3">{text}</span>
                    {countElement}
                </GridColumn>
                <GridColumn className="link-card__chevron-wrapper" width={['min-xs']}>
                    <ChevronRightLargeIcon className="link-card__chevron" />
                </GridColumn>
            </Grid>
        </Element>
    )
}
